<template>
  <div>
    <el-dialog title="选择销售单" :visible="show" width="1000px" @close="close">
      <el-form
        inline
        :model="searchData"
      >
        <el-form-item>
          <el-input
            placeholder="单号/客户/制单人"
            clearable
            prefix-icon="el-icon-search"
            v-model="searchData.searchInputValue"
            style="width: 250px"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="收款进度">
          <EnumSelect
            enumName="FundCollectProgressEnum"
            placeholder="请选择单据收款进度"
            v-model="searchData.fundCollectProgressEnumList"
            @change="changeAndSearch"
          >
          </EnumSelect>
        </el-form-item>
        <el-form-item label="出库进度">
          <EnumSelect
            enumName="CommodityOutputProgressEnum"
            placeholder="请选择单据出库进度"
            v-model="searchData.commodityOutputProgressEnumList"
            @change="changeAndSearch"
          >
          </EnumSelect>
        </el-form-item>
        <el-form-item label="单据金额">
          <NumberRangeInput
            :precision="2"
            :minVal.sync="searchData.minOrderAmount"
            :maxVal.sync="searchData.maxOrderAmount"
            @change="changeAndSearch"
          ></NumberRangeInput>
        </el-form-item>
        <el-form-item label="制单时间">
          <DateRangePicker
            :minVal.sync="searchData.minCreateDate"
            :maxVal.sync="searchData.maxCreateDate"
            @change="changeAndSearch"
          ></DateRangePicker>
        </el-form-item>
        <el-form-item label="提交时间">
          <DateRangePicker
            :minVal.sync="searchData.minSubmitDate"
            :maxVal.sync="searchData.maxSubmitDate"
            @change="changeAndSearch"
          ></DateRangePicker>
        </el-form-item>
        <el-form-item>
          <el-button
            icon="el-icon-search"
            type="primary"
            size="mini"
            @click="changeAndSearch"
            :loading="searchLoading"
          >
            查询
          </el-button>
          <el-button
            icon="el-icon-refresh"
            size="mini"
            @click="resetAndSearch"
            :loading="searchLoading"
          >
            重置
          </el-button>
        </el-form-item>
      </el-form>

      <el-table
        v-loading="searchLoading"
        :data="searchRes && searchRes.data ? searchRes.data : []"
        stripe
        :row-key="
          (row) => {
            return row.id + row.lastEditTime;
          }
        "
        ref="refsTable"
        @sort-change="sortChange"
        max-height="400px"
      >
        <el-table-column
          prop="orderNo"
          label="单号"
          width="150"
          align="center"
          header-align="center"
          fixed="left"
          sortable="custom"
        >
          <template slot-scope="scope">
            <span v-fmtype="scope.row.orderNo ? '' : 'info'">
              {{ scope.row.orderNo || "暂无" }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="customer.customerNo"
          label="客户"
          width="200"
          align="left"
          header-align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.customer.customerNo }}<br />
            {{ scope.row.customer.name }}
          </template>
        </el-table-column>
        <el-table-column
          prop="orderInfo.customerName"
          label="联系人信息"
          width="200"
          align="left"
          header-align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.customerName + " " + scope.row.customerPhoneNumber }}
            <br />
            {{ scope.row.customerAddress }}
          </template>
        </el-table-column>
        <el-table-column
          prop="orderAmount"
          label="单据金额"
          width="200"
          align="center"
          header-align="center"
          sortable="custom"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div class="fm-flex">
              <FmAmount :amount="scope.row.orderAmount"></FmAmount>
              <div
                class="fm-flex"
                v-if="scope.row.orderApprovalStatusEnum.Name == 'Approval'"
              >
                <div
                  class="fm-flex"
                  v-if="
                    scope.row.fundCollectProgressEnum.Name == 'UnCollected' ||
                    scope.row.fundCollectProgressEnum.Name ==
                      'PartialCollection'
                  "
                >
                  <span> (已收</span>
                  <FmAmount
                    :amount="scope.row.completedCollectAmount"
                  ></FmAmount>
                  <span>)</span>
                </div>
                <div
                  class="fm-flex"
                  v-if="
                    scope.row.fundCollectProgressEnum.Name == 'FullCollection'
                  "
                >
                  <span> (实收</span>
                  <FmAmount
                    :amount="
                      $jsTool.sub(
                        scope.row.completedCollectAmount,
                        scope.row.collectDisCountAmount
                      )
                    "
                  ></FmAmount>
                  <span>)</span>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="fundCollectProgressEnum.Desc"
          label="收款进度"
          width="100"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            <span
              v-fmtype="
                $jsTool.getFundCollectProgressType(
                  scope.row.fundCollectProgressEnum
                )
              "
              v-if="scope.row.orderApprovalStatusEnum.Name == 'Approval'"
              >{{ scope.row.fundCollectProgressEnum.Desc }}</span
            >
            <span v-fmtype="'warning'" v-else>——</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="commodityOutputProgressEnum.Desc"
          label="出库进度"
          width="100"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            <span
              v-fmtype="
                $jsTool.getCommodityOutputProgressType(
                  scope.row.commodityOutputProgressEnum
                )
              "
              v-if="scope.row.orderApprovalStatusEnum.Name == 'Approval'"
              >{{ scope.row.commodityOutputProgressEnum.Desc }}</span
            >
            <span v-fmtype="'warning'" v-else>——</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          width="150"
          align="left"
          header-align="center"
          sortable="custom"
          show-overflow-tooltip
        >
          <el-tooltip
            slot="header"
            content="点击可按制单时间排序"
            placement="top"
          >
            <span>
              <i class="el-icon-question"></i>
              制单信息
            </span>
          </el-tooltip>
          <template slot-scope="scope">
            {{ scope.row.creator.name }}<br />
            {{ scope.row.createTime }}
          </template>
        </el-table-column>
        <el-table-column
          prop="submitUser"
          width="150"
          align="left"
          header-align="center"
          sortable="custom"
          show-overflow-tooltip
        >
          <el-tooltip
            slot="header"
            content="点击可按提交时间排序"
            placement="top"
          >
            <span>
              <i class="el-icon-question"></i>
              提交信息
            </span>
          </el-tooltip>
          <template slot-scope="scope">
            <div v-if="scope.row.submitUserId">
              {{ scope.row.submitUser.name }}<br />
              {{ scope.row.submitTime }}
            </div>
            <span v-fmtype="'warning'" v-else>——</span>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          header-align="center"
          align="center"
          width="120"
        >
          <template slot-scope="scope">
            <el-button
              @click.native.stop="select(scope.row)"
              type="text"
              icon="el-icon-thumb"
            >
              选择销售单
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="searchRes && searchRes.pageInfo"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchRes.pageInfo.page"
        :page-sizes="[5, 10, 20, 50, 100]"
        :page-size="searchRes.pageInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="searchRes.total"
      >
      </el-pagination>
    </el-dialog>

    <el-dialog
      title="填写收款金额"
      :visible="editItemDialogShow"
      width="600px"
      @close="editItemDialogShow = false"
      v-if="editItemDialogShow"
      v-loading="loading"
    >
      <el-row class="fm-flex">
        <el-col :span="12">
          <span>关联单据</span>
        </el-col>
        <el-col :span="12" style="text-align: right">
          <p>
            <span>{{ editItem.orderNo }}</span>
          </p>
        </el-col>
      </el-row>

      <el-divider></el-divider>

      <el-row class="fm-flex">
        <el-col :span="12">
          <span>单据金额</span>
        </el-col>
        <el-col :span="12" style="text-align: right">
          <p>
            <span><FmAmount :amount="editItem.orderAmount"></FmAmount></span>
          </p>
        </el-col>
      </el-row>

      <el-divider></el-divider>

      <el-row class="fm-flex">
        <el-col :span="12">
          <el-tooltip effect="dark" content="" placement="top-start">
            <div slot="content" style="line-height: 1.5em;">
              <div style="font-weight: bold">待收金额说明</div>
              关联单据的最新待收金额
            </div>
            <i class="el-icon el-icon-question fm-mr-5"></i>
          </el-tooltip>
          <span>待收金额</span>
        </el-col>
        <el-col :span="12" style="text-align: right">
          <p>
            <span
              ><FmAmount :amount="editItem.toBeCollectAmount"></FmAmount
            ></span>
          </p>
        </el-col>
      </el-row>

      <el-divider></el-divider>

      <el-row class="fm-flex">
        <el-col :span="12">
          <span>收款金额</span>
        </el-col>
        <el-col :span="12" style="text-align: right">
          <p>
            <span>
              <el-input-number
                style="width: 170px"
                v-model="nowcollectAmount"
                label="收款金额"
                size="small"
                :precision="2"
                :min="0"
                :max="editItem.toBeCollectAmount"
                :step="1"
              ></el-input-number
            ></span>
          </p>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editItemCancel">取 消</el-button>
        <el-button type="primary" @click="editItemConfirm"> 选 择 </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Fmerpv2WebSaleOrderSelectDialog",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    from: {
      // 来源，SaleOrder 销售单|FundCollectOrder 收款单 | CommodityOutPutOrder 出库单
      type: String,
      default: null,
      require: true,
    },
    customerId: {
      type: String,
      default: null,
      require: true,
    },
    selectList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  watch: {
    show: {
      handler(newVal) {
        this.searchLoading = this.$options.data().searchLoading;
        this.searchData = this.$options.data().searchData;
        this.searchParam = this.$options.data().searchParam;
        this.searchRes = this.$options.data().searchRes;
        if (this.from == "SaleReturnOrder") {
          this.multiSelect = false;
        } else if (this.from == "FundCollectOrder") {
          this.multiSelect = true;
          this.searchParam.fundCollectProgressEnumList = [
            "UnCollected",
            "PartialCollection",
          ];
          // 为了与查询条件展示一致
          this.searchData.fundCollectProgressEnumList = [
            "UnCollected",
            "PartialCollection",
          ];
        } else if (this.from == "CommodityOutputOrder") {
          this.multiSelect = false;
          this.searchParam.commodityOutputProgressEnumList = [
            "NotOutput",
            "PartialOutput",
          ];
          this.searchData.commodityOutputProgressEnumList = [
            "NotOutput",
            "PartialOutput",
          ];
        }
        this.searchParam.customerId = this.customerId;
        if (this.show) {
          this.search(true);
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      // from: "",
      multiSelect: false,

      // 已选列表，多选时需回传
      // selectList: [],
      showSelectListPopup: false,

      selectFundCollectProgressEnumList: [],
      selectCommodityOutputProgressEnumList: [],

      // 搜索参数
      searchParam: {
        customerId: null,
        quickSearchInfoList: [
          {
            columns: [
              "orderNo",
              "customerName",
              "customerPhoneNumber",
              "customerAddress",
              "creator.name",
            ],
            quickSearchValue: null,
          },
          {
            columns: ["orderNo"],
            quickSearchValue: null,
          },
          {
            columns: ["customerName", "customerPhoneNumber", "customerAddress"],
            quickSearchValue: null,
          },
          {
            columns: ["creator.name"],
            quickSearchValue: null,
          },
        ],
        fundCollectProgressEnumList: null,
        commodityOutputProgressEnumList: null,
        minOrderAmount: null,
        maxOrderAmount: null,
        minCreateDate: null,
        maxCreateDate: null,
        minSubmitDate: null,
        maxSubmitDate: null,
        pageInfo: {
          page: 1,
          pageSize: 10,
        },
        sortInfo: null,
      },
      searchData: {
        searchInputValue: null,
        fundCollectProgressEnumList: null,
        commodityOutputProgressEnumList: null,
        minOrderAmount: null,
        maxOrderAmount: null,
        minCreateDate: null,
        maxCreateDate: null,
        minSubmitDate: null,
        maxSubmitDate: null,
      },
      searchLoading: false,
      searchRes: {},

      // 清单
      list: [],
      // 加载更多
      loadMore: {
        status: "loadmore",
        show: false,
      },

      editItemDialogShow: false,
      // 当前选择的item
      editItem: {},
      nowcollectAmount: "0.00",
      loading: false,
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    select(item) {
      // SaleReturnOrder | FundCollectOrder(multiSelect) | CommodityOutPutOrder
      if (this.multiSelect) {
        // this.searchLoading = true;
        // try {
        let index = this.selectList.findIndex(
          (d) => d.relatedOrderHeadId == item.id
        );
        if (item.fundCollectProgressEnum.Name == "NoNeedCollected") {
          this.$message({
            message: "所选销售单无需收款，请选择其他单据",
            type: "error",
          });
          return;
        }
        if (item.fundCollectProgressEnum.Name == "FullCollection") {
          this.$message({
            message: "所选销售单已全部收款，请选择其他单据",
            type: "error",
          });
          return;
        }
        if (item.toBeCollectAmount <= 0) {
          this.$message({
            message: "所选销售单待收款金额为 0 ，请选择其他单据",
            type: "error",
          });
          return;
        }

        if (index > -1) {
          this.editItem = {
            ...item,
          };
          this.nowcollectAmount = this.selectList[index].collectAmount;
        } else {
          this.editItem = item;
          this.nowcollectAmount = item.toBeCollectAmount;
        }

        this.editItemDialogShow = true;

        // let index = this.selectList.findIndex(
        //   (d) => d.relatedOrderHeadId == item.id
        // );
        // if (index > -1) {
        //   this.selectList.splice(index, 1, item);
        // } else {
        //   if (item.fundCollectProgressEnum.Name == "NoNeedCollected") {
        //     this.$message({
        //       message: "所选销售单无需收款，请选择其他单据",
        //       type: "error",
        //     });

        //     return;
        //   }
        //   if (item.fundCollectProgressEnum.Name == "FullCollection") {
        //     this.$message({
        //       message: "所选销售单已全部收款，请选择其他单据",
        //       type: "error",
        //     });
        //     return;
        //   }
        //   if (item.toBeCollectAmount <= 0) {
        //     this.$message({
        //       message: "所选销售单待收款金额为 0 ，请选择其他单据",
        //       type: "error",
        //     });
        //     return;
        //   }
        //   let itemNo =
        //     index > -1
        //       ? this.selectList[index].itemNo
        //       : this.selectList && this.selectList.length > 0
        //       ? this.selectList[this.selectList.length - 1].itemNo + 1
        //       : 1;
        //   this.selectList.push({
        //     itemNo: itemNo,
        //     relatedOrderHeadId: item.id,
        //     relatedSaleOrderHead: item,
        //     collectAmount: Number(item.toBeCollectAmount).toFixed(2),
        //     disCountAmount: "0.00",
        //     itemAmount: Number(item.toBeCollectAmount).toFixed(2),
        //   });
        // }
        // } finally {
        //   setTimeout(() => {
        //     this.searchLoading = false;
        //   }, 200);
        //   this.$emit("selectSaleOrder", this.selectList);
        // }
      } else {

        if (this.from == "CommodityOutputOrder") {
          if (item.commodityOutputProgressEnum.Name == "NoNeedOutput") {
            this.$message({
              message: "所选销售单无需出库，请选择其他单据",
              type: "error",
            });
            return;
          }
          if (item.commodityOutputProgressEnum.Name == "FullOutput") {
            this.$message({
              message: "所选销售单已全部出库，请选择其他单据",
              type: "error",
            });
            return;
          }
          if (item.toBeOutputQuantity <= 0) {
            this.$message({
              message: "所选销售单待出库商品数量为 0 ，请选择其他单据",
              type: "error",
            });
            return;
          }
        } else if (this.from == "SaleReturnOrder") {
          if (
            item.totalQuantity ==
            item.returningQuantity + item.completedReturnQuantity
          ) {
            this.$message({
              message: "所选销售单可退货商品数量为 0 ，请选择其他单据",
              type: "error",
            });
            return;
          }
        }
        this.$confirm("是否选择" + item.orderNo + "？", "操作提醒", {
          confirmButtonText: "选择",
          cancelButtonText: "取消",
          closeOnClickModal: false,
          closeOnPressEscape: false,
          closeOnHashChange: false,
        })
          .then(() => {
            this.$emit("selectSaleOrder", item);
          })
          .catch(() => {});
      }
    },

    editItemCancel() {
      this.editItemDialogShow = false;
      this.editItem = {};
    },
    editItemConfirm() {
      if (!this.editItem || !this.editItem.orderNo) {
        this.$message({
          message: "请选择销售单",
          type: "error",
        });
        return;
      }
      if (Number(this.nowcollectAmount) == 0) {
        this.$message({
          message: "请输入收款金额",
          type: "error",
        });
        return;
      }
      try {
        this.loading = true;
        let index = this.selectList.findIndex(
          (d) => d.relatedOrderHeadId == this.editItem.id
        );
        let itemNo =
          index > -1
            ? this.selectList[index].itemNo
            : this.selectList && this.selectList.length > 0
            ? this.selectList[this.selectList.length - 1].itemNo + 1
            : 1;
        let item = {
          itemNo: itemNo,
          relatedOrderHeadId: this.editItem.id,
          relatedSaleOrderHead: this.editItem,
          collectAmount: Number(this.nowcollectAmount).toFixed(2),
          disCountAmount: "0.00",
          itemAmount: Number(this.nowcollectAmount).toFixed(2),
        };
        if (index > -1) {
          this.selectList.splice(index, 1, item);
        } else {
          this.selectList.push(item);
        }
        this.editItemPopupShow = false;
        this.$emit("selectSaleOrder", this.selectList || []);
      } finally {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (!this.editItemPopupShow) {
          this.$emit("close");
        }
      }
    },
    handleSizeChange(val) {
      this.searchParam.pageInfo.pageSize = val;
      this.search(true, {
        showSuccessMessage: true,
      });
    },
    handleCurrentChange(val) {
      this.searchParam.pageInfo.page = val;
      this.search(false, {
        showSuccessMessage: true,
      });
    },
    changeAndSearch() {
      this.searchParam.quickSearchInfoList[0].quickSearchValue =
        this.searchData.searchInputValue;
      this.searchParam.fundCollectProgressEnumList =
        this.searchData.fundCollectProgressEnumList;
      this.searchParam.commodityOutputProgressEnumList =
        this.searchData.commodityOutputProgressEnumList;
      this.searchParam.minOrderAmount = this.searchData.minOrderAmount;
      this.searchParam.maxOrderAmount = this.searchData.maxOrderAmount;
      this.searchParam.minCreateDate = this.searchData.minCreateDate;
      this.searchParam.maxCreateDate = this.searchData.maxCreateDate;
      this.searchParam.minSubmitDate = this.searchData.minSubmitDate;
      this.searchParam.maxSubmitDate = this.searchData.maxSubmitDate;
      this.search(true, {
        showSuccessMessage: true,
      });
    },
    resetAndSearch() {
      this.searchData = this.$options.data().searchData;
      this.changeAndSearch();
    },
    sortChange(val) {
      this.searchParam.sortInfo =
        val && val.order
          ? {
              columnName: val.prop,
              order: val.order.replace("ending", "").toUpperCase(),
            }
          : null;
      this.search(true, {
        showSuccessMessage: true,
      });
    },
    async search(init, args) {
      this.searchLoading = true;
      if (init) {
        this.searchParam.pageInfo.page = 1;
      }
      let requestRes = await this.$api.saleOrder_findPageForSelect(
        this.searchParam,
        args
      );
      if (requestRes && requestRes.success) {
        this.searchRes = requestRes;
        this.searchRes.pageInfo = requestRes.pageInfo;
        this.$nextTick(() => {
          if (this.$refs.refsTable) {
            this.$refs.refsTable.doLayout();
          }
        });
      }
      if (requestRes.pageCount == 0) {
        this.searchRes = null;
      }
      setTimeout(() => {
        this.searchLoading = false;
      }, 200);
    },
  },
};
</script>

<style scoped>
/* 解决分割线存在粗细不一致异常 */
.el-divider {
  background-color: transparent;
  position: relative;
}

.el-divider--horizontal {
  height: 0;
  border-bottom: 1px solid #dcdfe6;
}
</style>


// WEBPACK FOOTER //
// src/components/SaleOrderSelectDialog.vue